export default __webpack_public_path__ + "static/media/front_raise_end.9cea4bf1.svg";